export default __webpack_public_path__ + "static/media/iced_mung_bean_drink_thumbnail.5559d8a3.JPG";